import * as React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  SxProps,
  Theme,
} from '@mui/material'

export type SummaryTableCell = number | string | React.ReactNode

export interface SummaryTableRow {
  cells: SummaryTableCell[]
}

interface SummaryTableProps {
  rows: SummaryTableRow[]
  headers?: SummaryTableCell[]
  header?: string
  firstColumnSx?: SxProps<Theme>
}

function formatCellValue(value: SummaryTableCell): React.ReactNode {
  if (typeof value === 'number') {
    return value.toLocaleString()
  }
  return value
}

export function SummaryTable({
  rows,
  headers,
  header,
  firstColumnSx,
}: SummaryTableProps) {
  return (
    <>
      {header && (
        <Typography
          variant="h6"
          gutterBottom
          sx={{ fontWeight: 'bold', fontStyle: 'italic' }}
        >
          {header}
        </Typography>
      )}
      <Table
        size="small"
        sx={{
          '& .MuiTableCell-root': { borderBottom: 'none' },
          width: 'auto',
        }}
      >
        {headers && (
          <TableHead>
            <TableRow>
              {headers.map((header, index) => (
                <TableCell
                  key={index}
                  sx={{
                    fontWeight: 'bold',
                    paddingTop: 0,
                    paddingBottom: 0,
                    whiteSpace: 'nowrap',
                    ...(index === 0 && firstColumnSx),
                  }}
                >
                  {formatCellValue(header)}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
        )}
        <TableBody>
          {rows.map((row, rowIndex) => {
            const isAlternate = rowIndex % 2 === 0

            return (
              <TableRow
                key={rowIndex}
                sx={
                  isAlternate
                    ? {
                        '& .MuiTableCell-root': {
                          backgroundColor: 'grey.100',
                        },
                      }
                    : {}
                }
              >
                {row.cells.map((cell, cellIndex) => (
                  <TableCell
                    key={cellIndex}
                    sx={{
                      paddingTop: 0,
                      paddingBottom: 0,
                      paddingRight: cellIndex === 0 ? 3 : 2,
                      paddingLeft: cellIndex === 0 ? 0 : 2,
                      whiteSpace: cellIndex === 0 ? 'nowrap' : 'normal',
                      ...(cellIndex === 0 && firstColumnSx),
                    }}
                  >
                    {formatCellValue(cell)}
                  </TableCell>
                ))}
              </TableRow>
            )
          })}
        </TableBody>
      </Table>
    </>
  )
}
